import React, { forwardRef, ReactNode } from 'react';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { CircularProgress, Typography } from '@mui/material';
import {
  CollapseContent,
  CollapseHeader,
  Count,
  ExpandMore,
  IconsContainer,
  LoaderContainer,
  TitleContainer,
  Wrapper,
} from 'src/components/Collapse/./styled';

interface CollapseProps {
  title: string;
  icon: ReactNode;
  expanded: boolean;
  children: ReactNode;
  loading?: boolean;
  count?: number;
  error?: boolean;
  onToggle: () => void;
}

export const Collapse = forwardRef<HTMLDivElement, CollapseProps>(
  (
    {
      title,
      children,
      icon,
      expanded,
      onToggle,
      loading,
      count,
      error = false,
    },
    ref,
  ) => (
    <Wrapper error={+error}>
      <CollapseHeader onClick={onToggle}>
        <TitleContainer>
          {icon}
          <Typography>{title}</Typography>
        </TitleContainer>
        <IconsContainer>
          {!!count && (
            <Count padding={count > 100 ? '0 3px' : undefined}>{count}</Count>
          )}
          <ExpandMore expand={+expanded}>
            <ArrowDropDownIcon />
          </ExpandMore>
        </IconsContainer>
      </CollapseHeader>
      <CollapseContent
        data-expanded={expanded ? 'true' : 'false'}
        in={expanded}
        timeout={0}
        ref={ref}
      >
        {loading && (
          <LoaderContainer>
            <CircularProgress />
          </LoaderContainer>
        )}
        {children}
      </CollapseContent>
    </Wrapper>
  ),
);
